import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ab8113"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { useRouter } from 'vue-router'
import { watchEffect } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const checkSubmit = localStorage.getItem('checkSubmit')

watchEffect(() => {
  if (!checkSubmit) router.push('/alumni/register_alumnus_community')
})
const transitLobby = () => {
  router.push('/alumni/lobby')
  localStorage.removeItem('checkSubmit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('SA27title')), 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(translate)('SA27descriptionFirst')), 1),
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_unref(translate)('SA27descriptionSecond')), 1)
    ]),
    _createVNode(Button, {
      title: _unref(translate)('titleButtonTop'),
      type: 'secondary',
      onClick: transitLobby
    }, null, 8, ["title"])
  ]))
}
}

})